webpackJsonp([77],{

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(819);


/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(565);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1619]);


// WEBPACK FOOTER //
// app/datetime.en-0709d40a59d3cc46c81f.js